export const translations = {
   is: {
      learnMore: "Nánar",
      header: {
         nav: {
            products: "Vörur",
            aboutUs: "Um okkur",
            contacts: "Tengiliðir",
         },
         button: "Hannaðu þitt eigið",
         aria: {
            openMenu: "Opna valmynd",
            closeMenu: "Loka valmynd",
         },
      },
      home: {
         heading: "Hanna – Byggja – Búa",
         button: "Hannaðu þitt eigið",
      },
      about: {
         title: "Um Nordroof",
         subtitle: "Ný Sýn – Þín Hönnun – Þitt Hús",
         h3: "Byggt undir einu þaki",
         p: "Í okkar ISO-vottuðu aðstöðu gerum við nýsköpun að veruleika. Aðstaðan okkar er staðsett í Litháen í yfir 5.000 m² . Við búum yfir hæfileikaríku teymi sem sérhæfir sig í gerð einingarlausna með vandvirkni að leiðarljósi. Við sinnum fjölbreyttum verkefnum og erum stolt af því að stjórna hverju skrefi framleiðslunnar undir einu þaki.",
      },
      contact: {
         title: "Hafðu samband",
         name: "Adda Hafborg",
         position: "Framkvæmdastjóri",
         email: "adda@nordroof.com",
         phone: "8887175",
         address: "Reykjaskógur Blágskógabyggð",
         postalCode: "806",
         form: {
            title: "Spurningar? Við höfum svörin",
            subtitle: "Svör",
            firstName: "Fornafn*",
            lastName: "Eftirnafn*",
            email: "Netfang*",
            phone: "Sími*",
            message: "Skilaboðin þín (valfrjálst)",
            notice: "Ég hef lesið og samþykki persónuverndarstefnu",
            submit: "Senda",
         },
      },
      footer: {
         brandDescription:
            "Nordroof – afhendum hágæða, sveigjanlegar einingarlausnir beint frá framleiðanda um alla Evrópu, studdar af áralangri reynslu og skuldbindingum um framúrskarandi gæði.",
         social: {
            instagram: "Instagram",
            facebook: "Facebook",
            linkedin: "LinkedIn",
            youtube: "YouTube",
         },
         nav: {
            company: {
               title: "Fyrirtækið",
               links: {
                  aboutUs: "Um okkur",
                  projects: "Verkefni",
                  products: "Vörur",
                  configurator: "Hönnunarkerfi",
                  team: "Teymið",
               },
            },
            products: {
               title: "Vörur",
               links: {
                  commercial: "Fyrirtækja",
                  private: "Einkaaðilar",
               },
            },
            info: {
               title: "Upplýsingar",
               links: {
                  forBusiness: "Fyrir fyrirtæki",
                  forPrivate: "Fyrir einstaklinga",
               },
            },
            contacts: {
               title: "Tengiliðir",
               email: "info@nordroof.com",
               phone: "8887175",
            },
         },
         bottomBar: {
            copyright: "© 2025 Nordroof. Allur réttur áskilinn",
            privacyPolicy: "Persónuverndarstefna",
            termsAndConditions: "Skilmálar",
         },
      },
      categories: {
         heading: "Byrjaðu á réttum grunni",
         description:
            "Veldu þá tegund sem hentar þér og gefur tóninn fyrir framhaldið",
         tabs: {
            allModels: "Allar gerðir",
         },
         button: {
            configure: "Hannaðu þitt eigið",
         },
         starts: "Byrjunarverð kr:",
      },
      configurator: {
         title: "Hannaðu húsið þitt",
         stages: {
            Facade: "Klæðning",
            Windows: "Gluggar",
            Floors: "Gólfefni",
            Walls: "Veggir",
            Doors: "Hurðar",
            Kitchen: "Eldhús",
            Bathroom: "Baðherbergi",
            Furniture: "Húsgögn",
            Foundation: "Grunnur",
            Upgrades: "Uppfærsla",
            Summary: "Samantekt",
            Offer: "Tilboð",
         },
         priceVat: "Verð:",
         getOffer: "Fá tilboð",
         next: "Næsta",
      },
      notices: { customPrice: "Sérsniðið verð eftir beiðni" },
      offer: {
         heading: "Þínar upplýsingar",
         description:
            "Segðu okkur frá þér og við sendum þér yfirlit yfir það sem þú valdir",
         fields: {
            name: { label: "Nafn", placeholder: "Nafn" },
            surname: { label: "Eftirnafn", placeholder: "Eftirnafn" },
            email: { label: "Netfang", placeholder: "Netfang" },
            telephone: { label: "Sími", placeholder: "Símanúmer" },
            postcode: { label: "Póstnúmer", placeholder: "Póstnúmer" },
            country: { label: "Land", placeholder: "Land" },
         },
         button: {
            submitRequest: "Senda beiðni",
         },
         privacy:
            "Við virðum friðhelgi þína. Upplýsingar þínar verða ekki sendar áfram.",
      },
   },
   en: {
      learnMore: "learn more",
      home: {
         heading: "Design. Build. Live.",
         button: "Design yours",
      },
      header: {
         nav: {
            products: "Products",
            aboutUs: "About us",
            contacts: "Contacts",
         },
         button: "Design yours",
         aria: {
            openMenu: "Open menu",
            closeMenu: "Close menu",
         },
      },
      about: {
         title: "ABOUT NORDROOF",
         subtitle: "Redefining modular living",
         h3: "Built under one roof",
         p: "At our dedicated facility, we bring innovation to life. Located in Lithuania and spanning 5000 m², our facilities bring together a talented team dedicated to crafting modular solutions with care and precision. With the capacity to deliver a wide range of projects, we’re proud to directly manage every step of production under one roof.",
      },
      contact: {
         title: "Contact us",
         name: "Adda Hafborg",
         position: "Manager",
         email: "adda@nordroof.com",
         phone: "8887175",
         form: {
            title: "Questions? We’ve",
            subtitle: "got answers",
            firstName: "First name *",
            lastName: "Last name *",
            email: "Email *",
            phone: "Phone *",
            message: "Your message (optional)",
            notice: "I have read and agree to the Privacy policy.",
            submit: "Submit",
         },
      },
      footer: {
         brandDescription:
            "Nordroof—delivering high-quality, flexible modular solutions direct from the manufacturer across Europe, backed by years of experience and a commitment to excellence",
         social: {
            instagram: "Instagram",
            facebook: "Facebook",
            linkedin: "LinkedIn",
            youtube: "YouTube",
         },
         nav: {
            company: {
               title: "Company",
               links: {
                  aboutUs: "About us",
                  projects: "Projects",
                  products: "Products",
                  configurator: "Configurator",
                  team: "Team",
               },
            },
            products: {
               title: "Products",
               links: {
                  commercial: "Commercial",
                  private: "Private",
               },
            },
            info: {
               title: "Information",
               links: {
                  forBusiness: "For business",
                  forPrivate: "For private",
               },
            },
            contacts: {
               title: "Contacts",
               email: "info@nordroof.com",
               phone: "8887175",
            },
         },
         bottomBar: {
            copyright: "© 2024 Nordroof. All rights reserved.",
            privacyPolicy: "Privacy policy",
            termsAndConditions: "Terms and conditions",
         },
      },
      categories: {
         heading: "Start with the right foundation",
         description:
            "Select the house type that sets the tone for everything else.",
         tabs: {
            allModels: "All models",
         },
         button: {
            configure: "Configure",
         },
         starts: "Starts at:",
      },
      configurator: {
         title: "Design your home",
         stages: {
            Facade: "Facade",
            Windows: "Windows",
            Floors: "Floors",
            Walls: "Walls",
            Doors: "Doors",
            Kitchen: "Kitchen",
            Bathroom: "Bathroom",
            Furniture: "Furniture",
            Foundation: "Foundation",
            Upgrades: "Upgrades",
            Summary: "Summary",
            Offer: "Offer",
         },
         priceVat: "Price (VAT included):",
         getOffer: "Get offer",
         next: "Next",
      },
      notices: {
         customPrice: "Custom price upon request",
      },
      offer: {
         heading: "Enter your contact details",
         description:
            "Tell us about yourself so we can prepare your personalised proposal.",
         fields: {
            name: { label: "Name", placeholder: "Name" },
            surname: { label: "Surname", placeholder: "Surname" },
            email: { label: "Email", placeholder: "Email" },
            telephone: { label: "Telephone", placeholder: "Phone number" },
            postcode: { label: "Postcode", placeholder: "Postcode" },
            country: { label: "Country", placeholder: "Country" },
         },
         button: {
            submitRequest: "Submit request",
         },
         privacy:
            "We value your privacy. Your information will remain confidential.",
      },
   },
};
